module.exports = __webpack_public_path__ + "images/51270e1885a767445919f2048ae2a1df-logo_wide.png";